import React, { useState } from 'react'

import { useAuthApi } from '../../store/mainContext'
import { ApiError } from '../../types'
import POWERS from '../../powers'
import Login from './views/login'

type SessionContextType = {
  state: { error?: ApiError; loaded: boolean }
  actions: {
    logOut(): void
    handleGoogleResponse(r: { error?: Error; accessToken: string }): void
  }
}

const SessionContext = React.createContext<SessionContextType>(
  {} as SessionContextType
)

const SessionContextProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [error, setError] = useState<ApiError>()
  const [loaded, setLoaded] = useState(true)

  const api = useAuthApi()

  const token = window.localStorage.getItem('token')

  let user: any

  try {
    user = JSON.parse(window.localStorage.getItem('user') || '')
  } catch (e) {}

  if (user && Array.isArray(user.powers)) {
    user.hasPower = (power: typeof POWERS[keyof typeof POWERS]) => {
      return (
        user.powers.indexOf('master') !== -1 ||
        user.powers.indexOf(power) !== -1
      )
    }
  }

  const logOut = () => {
    window.localStorage.clear()
    // window.localStorage.removeItem("token");
    // window.localStorage.removeItem("user");
    window.location.assign('/')
  }

  const handleGoogleResponse: SessionContextType['actions']['handleGoogleResponse'] =
    (r) => {
      console.log('Handle google response.')
      console.log(r)

      if (r.error) return

      setLoaded(false)

      const { accessToken } = r
      api
        .post('login', { access_token: accessToken })
        .then((res) => {
          window.localStorage.setItem('token', res.data.token)
          window.localStorage.setItem('user', JSON.stringify(res.data.user))
          setLoaded(true)
          window.location.assign('/')
        })
        .catch((e) => {
          console.log(e)

          setLoaded(true)
          setError({
            message: 'Sorry dude. Looks like you are out of this party.',
          })
        })
    }

  const state = { user, error, loaded }
  const actions = { logOut, handleGoogleResponse }

  return (
    <SessionContext.Provider value={{ state, actions }}>
      {token ? children : <Login />}
    </SessionContext.Provider>
  )
}

export { SessionContext as default, SessionContextProvider as Provider }
